/**
 * SafeIntersections legend helpers — wired into
 * `safeintersectionsConfig.parseLegendLayers`.
 *
 * Every layer is marked `excludeFromMapDataFilter: true` — SafeIntersections
 * has no map data filters (`config.filters = []`), so the global filter
 * expression should touch no layer.
 */

import {
	EIdentify,
	EPrioritize,
	ESafeIntersectionsModule,
	type ISafeIntersectionsSystemLayers
} from './interfaces';
import type { ICrashesSystemLayers } from '#lib/apps/safesystem/context/interfaces.js';
import { mapPriorityDescription } from './columns';
import type { MapLayer } from '#lib/stores/legendStore.svelte.js';
import { buildLegendLayers, parseMatchPaint, type Parsers } from '../legendHelpers';

const parsers: Parsers = {
	// Identify is a circle layer coloured via `circle-color`; on by default.
	[EIdentify.Identify]: (f) => parseMatchPaint(f, 'circle-color', { defaultEnabled: true }),
	[EPrioritize.Prioritize]: (f) =>
		parseMatchPaint(f, 'text-color', {
			labelFor: (raw) => mapPriorityDescription[raw],
			idSuffixFor: (raw) => mapPriorityDescription[raw].replace(' ', '_')
		})
};

export function parseLegendLayers(
	payload: ISafeIntersectionsSystemLayers & ICrashesSystemLayers
): MapLayer[] {
	return buildLegendLayers(
		payload,
		Object.values(ESafeIntersectionsModule),
		parsers,
		(_, defaultEnabled) => ({ enabled: defaultEnabled, excludeFromMapDataFilter: true })
	);
}
